/** The Figma frame everything is measured against ("Mobile Screen", 36:61). */
export const FRAME = { width: 430, height: 940 } as const;

/**
 * How far the screen container is allowed to stretch. Inside this band the
 * design keeps its natural size and the container itself flexes — the main
 * column's automatic gaps take up the slack, and the background is cropped
 * rather than resized. Below the minimum width the whole composition scales
 * down instead, so it never overflows a narrow phone.
 */
export const SCREEN_RANGE = {
  minWidth: 360,
  maxWidth: 430,
  minHeight: 640,
  maxHeight: 940,
} as const;

/** A box in Figma frame coordinates. */
export type Box = {
  readonly x: number;
  readonly y: number;
  readonly width: number;
  readonly height: number;
};
